<template>
	<div class="recipients">
		<el-row :gutter="20">
			<!-- 收件人列表管理 -->
			<el-col :span="12">
				<el-card>
					<div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
						<span>收件人列表</span>
						<el-button type="primary" @click="showAddListDialog" icon="el-icon-plus">
							新建列表
						</el-button>
					</div>
					
					<el-table 
						:data="lists" 
						v-loading="listsLoading" 
						style="width: 100%"
						:expand-row-keys="expandedRows"
						@expand-change="handleExpandChange"
						row-key="id">
						<el-table-column type="expand">
							<template slot-scope="props">
								<div class="recipient-expand-content">
									<div class="expand-header">
										<span class="expand-title">收件人列表 ({{ props.row.recipients ? props.row.recipients.length : 0 }}人)</span>
										<el-button 
											size="mini" 
											type="primary" 
											@click="selectList(props.row)"
											:disabled="selectedList && selectedList.id === props.row.id">
											{{ selectedList && selectedList.id === props.row.id ? '已选择' : '选择此列表' }}
										</el-button>
									</div>
									<div v-if="!props.row.recipients || props.row.recipients.length === 0" class="empty-recipients">
										<i class="el-icon-user"></i>
										<p>暂无收件人</p>
									</div>
									<div v-else class="recipient-list">
										<div 
											v-for="recipient in props.row.recipients" 
											:key="recipient.id" 
											class="recipient-item">
											<div class="recipient-info">
												<span class="recipient-name">{{ recipient.name || '未命名' }}</span>
												<span class="recipient-email">{{ recipient.email }}</span>
											</div>
											<div class="recipient-actions">
												<el-button 
													size="mini" 
													type="danger" 
													@click="deleteRecipientFromList(recipient, props.row)">
													删除
												</el-button>
											</div>
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="列表名称"></el-table-column>
						<el-table-column prop="createdAt" label="创建时间" width="150">
							<template slot-scope="scope">
								{{ formatDate(scope.row.createdAt) }}
							</template>
						</el-table-column>
						<el-table-column label="收件人数量" width="120">
							<template slot-scope="scope">
								<span class="recipient-count">{{ scope.row.recipientCount || 0 }}人</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="150">
							<template slot-scope="scope">
								<el-button size="mini" @click="selectList(scope.row)">选择</el-button>
								<el-button size="mini" type="danger" @click="deleteList(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-col>
			
			<!-- 收件人管理 -->
			<el-col :span="12">
				<el-card>
					<div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
						<span>收件人管理 {{ selectedList ? `- ${selectedList.name}` : '' }}</span>
						<el-button 
							type="success" 
							@click="showAddRecipientDialog" 
							icon="el-icon-plus"
							:disabled="!selectedList">
							添加收件人
						</el-button>
						<el-button type="primary" @click="showBulkImportDialog">批量导入</el-button>
					</div>
					
					<div v-if="!selectedList" class="empty-state">
						<i class="el-icon-user"></i>
						<p>请先选择一个收件人列表</p>
					</div>
					
					<el-table v-else :data="recipients" v-loading="recipientsLoading" style="width: 100%">
						<el-table-column prop="email" label="邮箱地址"></el-table-column>
						<el-table-column prop="name" label="姓名" width="120"></el-table-column>
						<el-table-column label="操作" width="120">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="deleteRecipient(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-col>
		</el-row>
		
		<!-- 新建列表对话框 -->
		<el-dialog title="新建收件人列表" :visible.sync="listDialogVisible" width="400px">
			<el-form :model="listForm" :rules="listRules" ref="listForm" label-width="80px">
				<el-form-item label="列表名称" prop="name">
					<el-input v-model="listForm.name" placeholder="请输入列表名称"></el-input>
				</el-form-item>
			</el-form>
			
			<div slot="footer">
				<el-button @click="listDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveList" :loading="listSaving">保存</el-button>
			</div>
		</el-dialog>
		
		<!-- 添加收件人对话框 -->
		<el-dialog title="添加收件人" :visible.sync="recipientDialogVisible" width="500px">
			<el-form :model="recipientForm" :rules="recipientRules" ref="recipientForm" label-width="80px">
				<el-form-item label="邮箱地址" prop="email">
					<el-input v-model="recipientForm.email" placeholder="请输入邮箱地址"></el-input>
				</el-form-item>
				
				<el-form-item label="姓名">
					<el-input v-model="recipientForm.name" placeholder="请输入姓名（可选）"></el-input>
				</el-form-item>
			</el-form>
			
			<div slot="footer">
				<el-button @click="recipientDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveRecipient" :loading="recipientSaving">保存</el-button>
			</div>
		</el-dialog>

		<!-- 批量导入对话框 -->
		<el-dialog
			title="批量导入收件人"
			:visible.sync="importDialogVisible"
			width="600px"
			@close="resetImportForm"
		>
			<el-form :model="importForm" label-width="100px">
				<el-form-item label="选择列表">
					<el-select v-model="importForm.listId" placeholder="请选择收件人列表" style="width: 100%">
						<el-option
							v-for="list in lists"
							:key="list.id"
							:label="list.name"
							:value="list.id"
						></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="导入方式">
					<el-radio-group v-model="importForm.method">
						<el-radio label="paste">粘贴文本</el-radio>
						<el-radio label="file">上传文件</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item v-if="importForm.method === 'paste'" label="收件人数据">
					<el-input
						v-model="importForm.textData"
						type="textarea"
						:rows="8"
						placeholder="请输入收件人数据，格式：&#10;邮箱1,姓名1&#10;邮箱2,姓名2&#10;或每行一个邮箱"
					></el-input>
					<div class="import-help">
						<p>支持的格式：</p>
						<p>• 每行一个邮箱：user@example.com</p>
						<p>• 邮箱和姓名用逗号分隔：user@example.com,张三</p>
					<p>• 粘贴模式：建议使用 .txt 纯文本格式内容</p>
					</div>
				</el-form-item>
				
				<el-form-item v-if="importForm.method === 'file'" label="选择文件">
					<el-upload
						ref="upload"
						:auto-upload="false"
						:on-change="handleFileChange"
						:file-list="fileList"
						drag
					>
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">支持任意文本文件（建议 .txt/.csv），文件大小不限</div>
					</el-upload>
				</el-form-item>
			</el-form>
			
			<div v-if="importPreview.length > 0" class="import-preview">
				<h4>预览数据（前10条）：</h4>
				<el-table :data="importPreview.slice(0, 10)" size="mini" border>
					<el-table-column prop="email" label="邮箱" width="200"></el-table-column>
					<el-table-column prop="name" label="姓名"></el-table-column>
				</el-table>
				<p>共 {{ importPreview.length }} 条数据</p>
			</div>
			
			<div slot="footer">
				<el-button @click="importDialogVisible = false">取消</el-button>
				<el-button type="info" @click="parseImportData">解析数据</el-button>
				<el-button
					type="primary"
					@click="handleBulkImport"
					:loading="importing"
					:disabled="importPreview.length === 0"
				>
					{{ importing ? '导入中...' : '开始导入' }}
				</el-button>
			</div>
		</el-dialog>

		<!-- 导入结果对话框 -->
		<el-dialog
			title="导入结果"
			:visible.sync="resultDialogVisible"
			width="420px"
		>
			<div class="import-result" style="text-align:center; padding: 10px 0;">
				<el-result icon="success" title="成功导入" subTitle="收件人数据已导入列表" />
			</div>
			<div slot="footer">
				<el-button type="primary" @click="resultDialogVisible = false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'Recipients',
	data() {
		return {
			lists: [],
			recipients: [],
			selectedList: null,
			listsLoading: false,
			recipientsLoading: false,
			
			// 列表相关
			listDialogVisible: false,
			listSaving: false,
			listForm: { name: '' },
			listRules: {
				name: [
					{ required: true, message: '请输入列表名称', trigger: 'blur' }
				]
			},
			
			// 收件人相关
			recipientDialogVisible: false,
			recipientSaving: false,
			recipientForm: { email: '', name: '' },
			recipientRules: {
				email: [
					{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
					{ type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
				]
			},

			// 批量导入相关
			importDialogVisible: false,
			importing: false,
			importForm: {
				listId: null,
				method: 'paste',
				textData: ''
			},
			fileList: [],
			importPreview: [],
			importResult: {},
			
			// 结果对话框
			resultDialogVisible: false,
			
			// 展开的行
			expandedRows: []
		}
	},
	mounted() {
		this.loadLists();
	},
	methods: {
		async loadLists() {
			this.listsLoading = true;
			try {
				const userId = this.$store.getters.userId;
				const response = await this.$http.get('/api/recipient-lists', {
					params: { userId: userId }
				});
				this.lists = response.data;
				
				// 为每个列表加载收件人详情（用于下拉框显示）
				for (let list of this.lists) {
					try {
						console.log(`正在加载列表 ${list.id} (${list.name}) 的收件人...`);
						const recipientsResponse = await this.$http.get(`/api/recipient-lists/${list.id}/recipients`);
						list.recipients = recipientsResponse.data || [];
						console.log(`列表 ${list.id} 加载了 ${list.recipients.length} 个收件人:`, list.recipients);
					} catch (error) {
						console.error(`加载列表 ${list.id} 的收件人失败:`, error);
						list.recipients = [];
					}
				}
			} catch (error) {
				console.error('加载列表失败:', error);
				this.$message.error('加载列表失败');
			} finally {
				this.listsLoading = false;
			}
		},
		
		async selectList(list) {
			this.selectedList = list;
			await this.loadRecipients(list.id);
		},
		
		async loadRecipients(listId) {
			this.recipientsLoading = true;
			try {
				const response = await this.$http.get(`/api/recipient-lists/${listId}/recipients`);
				this.recipients = response.data;
			} catch (error) {
				console.error('加载收件人失败:', error);
				this.$message.error('加载收件人失败');
			} finally {
				this.recipientsLoading = false;
			}
		},
		
		showAddListDialog() {
			this.listForm = { name: '' };
			this.listDialogVisible = true;
		},
		
		async saveList() {
			this.$refs.listForm.validate(async (valid) => {
				if (valid) {
					this.listSaving = true;
					try {
						const userId = this.$store.getters.userId;
						const requestData = {
							userId: userId,
							name: this.listForm.name
						};
						await this.$http.post('/api/recipient-lists', requestData);
						this.$message.success('创建成功');
						this.listDialogVisible = false;
						this.loadLists();
					} catch (error) {
						console.error('创建失败:', error);
						this.$message.error('创建失败');
					} finally {
						this.listSaving = false;
					}
				}
			});
		},
		
		async deleteList(list) {
			try {
				await this.$confirm('确定要删除这个列表吗？删除后列表中的所有收件人也会被删除。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				});
				
				await this.$http.delete(`/api/recipient-lists/${list.id}`);
				this.$message.success('删除成功');
				if (this.selectedList && this.selectedList.id === list.id) {
					this.selectedList = null;
					this.recipients = [];
				}
				this.loadLists();
			} catch (error) {
				if (error !== 'cancel') {
					console.error('删除失败:', error);
					this.$message.error('删除失败');
				}
			}
		},
		
		handleExpandChange(row, expandedRows) {
			this.expandedRows = expandedRows.map(r => r.id);
		},
		
		async deleteRecipientFromList(recipient, list) {
			try {
				await this.$confirm('确定要删除这个收件人吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				});
				
				await this.$http.delete(`/api/recipient-lists/${list.id}/recipients/${recipient.id}`);
				this.$message.success('删除成功');
				
				// 重新加载收件人详情
				await this.loadRecipients(list.id);
				// 重新加载所有列表以更新展开内容
				await this.loadLists();
				
				// 如果当前选中的列表被删除，需要重新选择
				if (this.selectedList && this.selectedList.id === list.id) {
					await this.loadRecipients(list.id);
				}
			} catch (error) {
				if (error !== 'cancel') {
					console.error('删除失败:', error);
					this.$message.error('删除失败');
				}
			}
		},
		
		showAddRecipientDialog() {
			this.recipientForm = { email: '', name: '' };
			this.recipientDialogVisible = true;
		},
		
		async saveRecipient() {
			this.$refs.recipientForm.validate(async (valid) => {
				if (valid) {
					this.recipientSaving = true;
					try {
						const response = await this.$http.post(`/api/recipient-lists/${this.selectedList.id}/recipients`, this.recipientForm);
						console.log('添加收件人成功:', response.data);
						this.$message.success('添加成功');
						this.recipientDialogVisible = false;
						// 重新加载收件人详情
						await this.loadRecipients(this.selectedList.id);
						// 重新加载所有列表以更新下拉框中的收件人信息
						await this.loadLists();
					} catch (error) {
						console.error('添加失败:', error);
						this.$message.error('添加失败');
					} finally {
						this.recipientSaving = false;
					}
				}
			});
		},
		
		async deleteRecipient(recipient) {
			try {
				await this.$confirm('确定要删除这个收件人吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				});
				
				await this.$http.delete(`/api/recipient-lists/${this.selectedList.id}/recipients/${recipient.id}`);
				this.$message.success('删除成功');
				// 重新加载收件人详情
				await this.loadRecipients(this.selectedList.id);
				// 重新加载所有列表以更新下拉框中的收件人信息
				await this.loadLists();
			} catch (error) {
				if (error !== 'cancel') {
					console.error('删除失败:', error);
					this.$message.error('删除失败');
				}
			}
		},
		
		formatDate(date) {
			if (!date) return '';
			return new Date(date).toLocaleString();
		},

		showBulkImportDialog() {
			this.importDialogVisible = true;
		},
		
		resetImportForm() {
			this.importForm = {
				listId: null,
				method: 'paste',
				textData: ''
			};
			this.fileList = [];
			this.importPreview = [];
			this.importResult = {};
		},
		
		handleFileChange(file) {
			const name = file.name || '';
			if (!name.toLowerCase().endsWith('.txt')) {
				this.$message.error('仅支持 .txt 纯文本文件');
				this.fileList = [];
				return;
			}
			this.fileList = [file];
			this.parseFileData(file.raw);
		},
		
		parseFileData(file) {
			const reader = new FileReader();
			reader.onload = (e) => {
				this.importForm.textData = e.target.result;
				this.parseImportData();
			};
			reader.readAsText(file);
		},
		
		parseImportData() {
			if (!this.importForm.textData.trim()) {
				this.$message.warning('请输入或选择要导入的数据');
				return;
			}
			
			const lines = this.importForm.textData.trim().split('\n');
			const recipients = [];
			
			for (let line of lines) {
				line = line.trim();
				if (!line) continue;
				
				let email, name = '';
				
				if (line.includes(',')) {
					// 包含逗号，分割邮箱和姓名
					const parts = line.split(',').map(p => p.trim());
					email = parts[0];
					name = parts.length > 1 ? parts[1] : '';
				} else {
					// 只有邮箱
					email = line;
				}
				
				if (email && this.isValidEmail(email)) {
					recipients.push({ email, name });
				}
			}
			
			this.importPreview = recipients;
			
			if (recipients.length === 0) {
				this.$message.warning('未解析到有效的邮箱地址');
			} else {
				this.$message.success(`解析到 ${recipients.length} 个有效邮箱`);
			}
		},
		
		isValidEmail(email) {
			const emailPattern = /^[A-Za-z0-9+_.-]+@([A-Za-z0-9.-]+\.[A-Za-z]{2,})$/;
			return emailPattern.test(email);
		},
		
		async handleBulkImport() {
			if (!this.importForm.listId) {
				this.$message.warning('请选择收件人列表');
				return;
			}
			
			if (this.importPreview.length === 0) {
				this.$message.warning('没有可导入的数据');
				return;
			}
			
			this.importing = true;
			try {
				const response = await this.$http.post('/api/recipient-lists/bulk-import', {
					listId: this.importForm.listId,
					recipients: this.importPreview
				});
				
				this.importResult = response.data;
				this.importDialogVisible = false;
				this.resultDialogVisible = true;
				
				// 刷新收件人列表
				if (this.selectedList && this.selectedList.id === this.importForm.listId) {
					await this.loadRecipients(this.selectedList.id);
				}
				// 重新加载所有列表以更新下拉框中的收件人信息
				await this.loadLists();
				
			} catch (error) {
				console.error('批量导入失败:', error);
				this.$message.error('批量导入失败');
			} finally {
				this.importing = false;
			}
		}
	}
}
</script>

<style scoped>
.recipients {
	padding: 20px;
}

.empty-state {
	text-align: center;
	padding: 40px 0;
	color: #909399;
}

.empty-state i {
	font-size: 48px;
	margin-bottom: 10px;
}

.import-help {
	margin-top: 10px;
	font-size: 12px;
	color: #909399;
}

.import-help p {
	margin: 2px 0;
}

.import-preview {
	margin-top: 20px;
	padding: 15px;
	background: #f5f7fa;
	border-radius: 4px;
}

.import-preview h4 {
	margin-top: 0;
	color: #303133;
}

.import-result {
	padding: 10px 0;
}

.result-summary {
	margin-bottom: 20px;
}

.result-card {
	text-align: center;
	padding: 20px 10px;
}

.result-card.success {
	border-left: 4px solid #67C23A;
}

.result-card.warning {
	border-left: 4px solid #E6A23C;
}

.result-card.error {
	border-left: 4px solid #F56C6C;
}

.result-number {
	font-size: 28px;
	font-weight: bold;
	margin-bottom: 5px;
}

.result-card.success .result-number {
	color: #67C23A;
}

.result-card.warning .result-number {
	color: #E6A23C;
}

.result-card.error .result-number {
	color: #F56C6C;
}

.result-label {
	font-size: 14px;
	color: #606266;
}

.failed-list, .duplicate-list {
	margin-top: 15px;
	max-height: 200px;
	overflow-y: auto;
}

.failed-list h4, .duplicate-list h4 {
	margin-bottom: 10px;
	color: #303133;
}

.failed-list ul, .duplicate-list ul {
	margin: 0;
	padding-left: 20px;
}

.failed-list li, .duplicate-list li {
	margin-bottom: 5px;
	color: #606266;
}

.recipient-dropdown-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 5px 0;
	min-width: 200px;
}

.recipient-name {
	font-weight: bold;
	margin-right: 10px;
	color: #303133;
}

.recipient-email {
	color: #606266;
	font-size: 12px;
}

.recipient-expand-content {
	padding: 20px;
	background: #f8f9fa;
	border-radius: 4px;
}

.expand-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 15px;
	padding-bottom: 10px;
	border-bottom: 1px solid #e4e7ed;
}

.expand-title {
	font-size: 16px;
	font-weight: bold;
	color: #303133;
}

.empty-recipients {
	text-align: center;
	padding: 30px 0;
	color: #909399;
}

.empty-recipients i {
	font-size: 48px;
	margin-bottom: 10px;
}

.recipient-list {
	max-height: 300px;
	overflow-y: auto;
}

.recipient-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px;
	margin-bottom: 8px;
	background: white;
	border-radius: 4px;
	border: 1px solid #e4e7ed;
}

.recipient-info {
	display: flex;
	flex-direction: column;
	flex: 1;
}

.recipient-item .recipient-name {
	font-weight: bold;
	color: #303133;
	margin-bottom: 4px;
}

.recipient-item .recipient-email {
	color: #606266;
	font-size: 12px;
}

.recipient-actions {
	margin-left: 15px;
}

.recipient-count {
	font-weight: bold;
	color: #409EFF;
}
</style> 